<template>
    <div class="MovingBrands position-relative">
      <div class="items" ref="slider" dir="rtl">
        <div class="d-flex moving-div" ref="moving">
          <div class="margin-brand" :key="obj" v-for="obj in brands">
            <router-link @dragstart.prevent :to="'/brand/'+obj.slug">
              <img class="brand-img-slider bg-brand mx-3" v-lazy="$MEDIA + obj.image" :alt="obj.name">
            </router-link>
          </div>
        </div>
      </div>
      <button aria-label="بعدی" class="position-absolute left" @click="n">
        <i class="fa fa-arrow-left color-black fs-3" aria-hidden="true"></i>
      </button>
      <button aria-label="قبلی" class="position-absolute right" @click="p">
        <i class="fa fa-arrow-right color-black fs-3" aria-hidden="true"></i>
      </button>
    </div>
</template>
<script>
export default {
  name: 'MovingBrands',
  data () {
    return {
      isDown: false,
      startX: null,
      scrollLeft: null,
      brands: [],
      end: 2000,
      current: 0,
      interval: null
    }
  },
  methods: {
    n: function () {
      clearInterval(this.interval)
      this.current += 152
      if (this.current >= this.end) {
        clearInterval(this.interval)
        this.current = this.end
      }
      this.$refs.moving.style.translate = this.current + 'px'
    },
    p: function () {
      clearInterval(this.interval)
      this.current -= 152
      if (this.current < 0) {
        this.current = 0
      }
      this.$refs.moving.style.translate = this.current + 'px'
    }
  },
  unmounted () {
    clearInterval(this.interval)
  },
  mounted () {
    this.brands = this.$categories.reduce((acc, category) => { return acc.concat(category.brands) }, []).sort((a, b) => b.view - a.view)
    this.brands = this.brands.filter((brand, index, self) => index === self.findIndex((b) => b.slug === brand.slug)).slice(0, 50)
    setTimeout(() => {
      this.end = this.$refs.moving.scrollWidth - this.$refs.slider.offsetWidth
      this.interval = setInterval(() => {
        if (this.current >= this.end) {
          clearInterval(this.interval)
          this.current = this.end
        }
        this.current += 152
        this.$refs.moving.style.translate = this.current + 'px'
      }, 3000)
    }, 2000)
  }
}
</script>
<style scoped>

.brand-img-slider{
  width: 120px;
  border: solid 1px #d1d1d1;
  border-radius: 24px;
  margin: 10px;
  padding: 15px;
}
.items {
  position: relative;
  width: 100%;
  overflow: hidden;
  transition: all 0.2s;
  transform: scale(0.97);
  will-change: transform;
  user-select: none;
  cursor: pointer;
  scrollbar-width: none;
}

.items.active {
  cursor: grabbing;
  cursor: -webkit-grabbing;
  transform: scale(1);
}
.moving-div{
  transition: 0.8s;
}
button {
  all: unset; /* Resets all properties */
  display: inline-block;
  cursor: pointer;
}
.right{
  right: 0;
  top: 0;
  bottom: 0;
}
.left{
  left: 0;
  top: 0;
  bottom: 0;
}
</style>
